import React, { useEffect, useState } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import {
    Button,
    DialogActions,
    Dialog,
    DialogContent,
    IconButton,
    DialogTitle,
    Slide
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { SupplierPassbookPopUpIcon } from '../../../components/icons';
import { connect } from "react-redux";


const useStyles = makeStyles((theme) => ({

    dialogContentV1: {
        paddingLeft: 64,
        paddingRight: 64,
        paddingTop: 24,
        paddingBottom: '0px !important'
    },
    textV1: {
        fontSize: 20,
        textAlign: 'center',
        marginTop: 24
    },
    dialogActionsV1: {
        paddingLeft: 64,
        paddingRight: 64,
        paddingTop: 24,
        paddingBottom: '32px !important',
        display: 'flex',
        justifyContent: 'center'
    },
    buttonV1: {
        textTransform: 'capitalize',
        color: 'white',
        backgroundColor: '#5170f0',
        fontWeight: 600,
        paddingTop: 17,
        paddingBottom: 17,
        paddingRight: 124,
        paddingLeft: 124,
        borderRadius: 8,
        fontSize: 16,
        '&:hover': {
            backgroundColor: '#5170f0'
        }
    },
    imgV1: {
        width: '500px',
        height: '222px'
    },
    dialogTitleV1: {
        paddingTop: 40,
        paddingRight: 36,
        paddingLeft: 36,
        paddingBottom: '0px !important',
        "& .MuiTypography-root": {
            display: 'flex',
            justifyContent: 'center'
        }
    },
    divV3: {
        textAlign: 'center'
    },
    closeIcon: {
        color: 'grey',
        fontSize: 18
    },
    divV1: {
        fontSize: 16,
        fontWeight: 500
    },
    divV2: {
        fontSize: 32,
        fontWeight: 500,
        marginTop: -10
    },
    closeIcon: {
        color: 'grey',
        fontSize: 18
    },
    divCloseButton: {
        position: 'absolute',
        top: 30,
        right: 34,
    },
    paper1: {
        borderRadius: 16
    },
    widthV1: {
        width: '628px !important',
        height: '510px !important'
    }

}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const SupplierPassbookPopUp = ({ open, onClose, onAddSupplierPayment }) => {

    const [dialogOpen, setDialogOpen] = useState(open);

    const classes = useStyles();

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
        localStorage.setItem('SupplierPassbookPopUpShown', true)
    }

    const handleAddPayment = () => {
        handleClose();
        onAddSupplierPayment();
    }

    return (
        <>
            <Dialog
                open={dialogOpen}
                fullWidth
                maxWidth={'sm'}
                TransitionComponent={Transition}
                keepMounted
                disableEscapeKeyDown={true}
                disableBackdropClick={true}
                onClose={handleClose}
                aria-labelledby="sim-tracking-pop-up"
                aria-describedby="sim-tracking-pop-up-description"
                classes={{ paperWidthSm: classes.widthV1, paperScrollPaper: classes.paper1 }}
            >
                <DialogTitle className={classes.dialogTitleV1}>
                    <div className={classes.divV3}>
                        <div className={classes.divV1}>Introducing</div>
                        <div className={classes.divV2}>Supplier Passbook</div>
                    </div>
                    <div className={classes.divCloseButton}>
                        <IconButton onClick={handleClose} >
                            <CloseIcon className={classes.closeIcon} />
                        </IconButton>
                    </div>
                </DialogTitle>

                <DialogContent>
                    <SupplierPassbookPopUpIcon className={classes.imgV1} />
                    <div className={classes.textV1}>Now, Add bulk Supplier Payments</div>
                </DialogContent>

                <DialogActions className={classes.dialogActionsV1}>
                    <Button variant="contained" className={classes.buttonV1} onClick={() => handleAddPayment()}>
                        Add Payment
                    </Button>
                </DialogActions>
            </Dialog>

        </>
    )
}

export default SupplierPassbookPopUp;